import { FC } from "react";
import { MainContainerFullWidth } from "../../styles/basicStyles";
import { useTranslation } from "next-i18next";
import { BlogPost, BlogPageType } from "../../models/blog";
import { colors } from "../../styles/colors";
import ContactBanner from "../../components/views/contactBanner";
import GlobalBanner from "../../components/views/globalBanner";
import Articles from "./components/articles";
import Metatags from "../../components/metatags";

interface Props {
  data: BlogPageType;
  posts: {
    items: BlogPost[];
    total: number;
    limit: number;
    page: number;
    pages: number;
  }
}

const Blog: FC<Props> = ({ data, posts }) => {
  const { i18n: { language } } = useTranslation();

  return (
    <>
      <Metatags
        title={data.meta_title && data.meta_title[language]}
        description={data.meta_description && data.meta_description[language]}
        keywords={data.meta_keywords && data.meta_keywords[language]}
        image={data.meta_image?.url}
      />
      <GlobalBanner
        page={data?.category && data?.category[language].toUpperCase()}
        title={data?.title && data?.title[language]}
        description={data?.description && data?.description[language]}
        bgColor={colors.desertStorm}
        blacktext
        dot
        origin='blog'
      />
      <Articles
        data={data}
        postsProps={posts}
      />
      <MainContainerFullWidth>
        <ContactBanner />
      </MainContainerFullWidth>
    </>
  );
};

export default Blog;
